import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { BRAND, NAV } from "../../lib/site";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1], delay: 0.2 }}
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled ? "bg-[#030712]/85 backdrop-blur-xl border-b border-white/10 py-3" : "bg-transparent py-6"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img src={BRAND.logo} alt="Yes Global" className="h-10 w-10 rounded-full object-cover ring-1 ring-white/20" />
          <div className="leading-none">
            <span className="block font-display text-[15px] font-bold tracking-tight text-white">YES GLOBAL</span>
            <span className="block font-body text-[10px] tracking-[0.32em] text-[#00D166]">CONSULTANTS</span>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className="relative font-body text-sm text-white/70 hover:text-white transition-colors duration-300 after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-[#00D166] hover:after:w-full after:transition-all after:duration-300"
            >
              {n.label}
            </a>
          ))}
          <Link
            to="/blog"
            data-testid="nav-link-insights"
            className="relative font-body text-sm text-white/70 hover:text-white transition-colors duration-300 after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-[#00D166] hover:after:w-full after:transition-all after:duration-300"
          >
            Insights
          </Link>
          <a
            href="#contact"
            data-testid="nav-cta-consult"
            className="font-body text-sm font-semibold bg-[#00D166] text-[#030712] px-5 py-2.5 hover:bg-white transition-colors duration-300"
          >
            Consult Us
          </a>
        </nav>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#030712]/95 backdrop-blur-xl border-t border-white/10 mt-3">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${n.label.toLowerCase()}`}
                className="font-body text-white/80 text-lg"
              >
                {n.label}
              </a>
            ))}
            <Link to="/blog" onClick={() => setOpen(false)} data-testid="nav-mobile-link-insights" className="font-body text-white/80 text-lg">Insights</Link>
            <a href="#contact" onClick={() => setOpen(false)} className="font-body font-semibold bg-[#00D166] text-[#030712] px-5 py-3 text-center">
              Consult Us
            </a>
          </div>
        </div>
      )}
    </motion.header>
  );
}
